import React from 'react'
import { Link } from 'react-router-dom'

import UserMenu from './user-menu'



export default () => (
  <header className="site-header">
    <div className="container">
      <div className="row justify-content-between align-items-center">
        <div className="col header__logo-col flex-shrink-md">
          <Link to={ '/' } className="header__logo">
            <i className="zmdi zmdi-navigation" /> <span>CacheReady</span>
          </Link>
        </div>

        <div className="col header__menu-toggler-col flex-shrink-md">
          <UserMenu />
        </div>
      </div>
    </div>
  </header>
)



// WEBPACK FOOTER //
// ./src/components/app/header.js